module.exports = function anonymous(locals
) {
with(locals || {}) {
  try {
   var _$output="<div class=\"loading_message_container\"><div id=\"loading_message\"></div></div><div class=\"alert-container\"></div><div id=\"content\"></div><div id=\"overlay-content\"></div>";
 return _$output;  } catch (e) {
    return "\n<pre class='error'>" + Haml.html_escape(e.stack) + "</pre>\n";
  }
}
};